module.exports = __webpack_public_path__ + "img/user.44980e70.svg";